import { render, staticRenderFns } from "./HazardApprove.vue?vue&type=template&id=b14bd478"
import script from "./HazardApprove.vue?vue&type=script&lang=js"
export * from "./HazardApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports